import _metadataKeys from "../../dict/metadataKeys.js";
import _Metadata from "../../classes/metadata.js";
const Metadata = _Metadata;
const metadataKeys = _metadataKeys;

/* Map a raw field name to its standard key (eg. "Author Name" -> "author"). Unknown names are kept as-is (trimmed) so user defined metadata still passes through. */
function normaliseMetadataKey(rawName) {
  const alias = metadataKeys.aliases[metadataKeys.normaliseName(rawName)];
  return alias || String(rawName || "").trim();
}

/* Metadata entries have historically used name/key/prop for the field name */
function entryName(entry) {
  return entry ? entry.name ?? entry.key ?? entry.prop : undefined;
}
function isEmpty(value) {
  return value === undefined || value === null || String(value).trim() === "";
}

/* Add or replace a metadata entry on the Event Group using the standard key. Empty values are ignored. */
function setMetadata(eventGroup, rawName, value, opts = {}) {
  if (!eventGroup || isEmpty(rawName) || isEmpty(value)) {
    return eventGroup;
  }
  const name = normaliseMetadataKey(rawName);
  const entry = new Metadata({
    name,
    type: opts.type || "text-input",
    value: typeof value === "string" ? value.trim() : value,
    source: opts.source || (rawName !== name ? rawName : undefined)
  });
  if (!Array.isArray(eventGroup.metadata)) {
    eventGroup.metadata = [];
  }
  const index = eventGroup.metadata.findIndex(m => normaliseMetadataKey(entryName(m)) === name);
  if (index > -1) {
    eventGroup.metadata[index] = entry;
  } else {
    eventGroup.metadata.push(entry);
  }
  return eventGroup;
}

/* Return the value of the first metadata entry matching the key (or any of its aliases), or undefined. */
function getMetadata(eventGroup, rawName) {
  if (!eventGroup || !Array.isArray(eventGroup.metadata)) {
    return undefined;
  }
  const name = normaliseMetadataKey(rawName);
  const entry = eventGroup.metadata.find(m => normaliseMetadataKey(entryName(m)) === name && !isEmpty(m.value));
  return entry ? entry.value : undefined;
}
export default {
  normaliseMetadataKey,
  setMetadata,
  getMetadata
};